import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69dd5e19"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "result-card__container" }
const _hoisted_2 = { class: "result-card__container-info" }
const _hoisted_3 = { class: "result-card__container-icons" }
const _hoisted_4 = { class: "card-container-mobile only-mobile" }
const _hoisted_5 = { class: "result-card-mobile__container" }
const _hoisted_6 = { class: "mb--15" }
const _hoisted_7 = { class: "result-card-mobile__container-icons" }

import { BaseCard } from '@/components/UI';

export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingOfferCard',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_base_skeleton_loader = _resolveComponent("base-skeleton-loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(BaseCard), { class: "none-Mobile card-container" }, {
      default: _withCtx(() => [
        _createVNode(_component_base_skeleton_loader, { type: "img" }),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createVNode(_component_base_skeleton_loader, {
                class: "mb--5",
                type: "mediumText"
              }),
              _createVNode(_component_base_skeleton_loader, { type: "text" })
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_base_skeleton_loader, {
                class: "mb--5",
                type: "text"
              }),
              _createVNode(_component_base_skeleton_loader, { type: "text" })
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_base_skeleton_loader, {
                class: "mb--5",
                type: "text"
              }),
              _createVNode(_component_base_skeleton_loader, { type: "text" })
            ]),
            _createVNode(_component_base_skeleton_loader, { type: "btn" })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_base_skeleton_loader, {
              style: { borderRadius: '50%' },
              type: "icon"
            }),
            _createVNode(_component_base_skeleton_loader, { type: "icon" }),
            _createVNode(_component_base_skeleton_loader, { type: "icon" }),
            _createVNode(_component_base_skeleton_loader, { type: "icon" }),
            _createVNode(_component_base_skeleton_loader, { type: "icon" })
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_base_skeleton_loader, { type: "img" }),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_base_skeleton_loader, {
              class: "mb--3",
              type: "mediumText"
            }),
            _createVNode(_component_base_skeleton_loader, {
              styles: { height: '14px', width: '100px' },
              type: "text"
            })
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_base_skeleton_loader, {
              styles: { height: '14px', width: '100px' },
              class: "mb--3",
              type: "text"
            }),
            _createVNode(_component_base_skeleton_loader, {
              styles: { height: '14px', width: '100px' },
              class: "mb--3",
              type: "text"
            }),
            _createVNode(_component_base_skeleton_loader, {
              styles: { height: '14px', width: '100px' },
              type: "text"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_base_skeleton_loader, {
            styles: { borderRadius: '50%' },
            type: "icon"
          }),
          _createVNode(_component_base_skeleton_loader, {
            styles: { height: '20px', width: '20px', borderRadius: '5px' },
            type: "icon"
          }),
          _createVNode(_component_base_skeleton_loader, {
            styles: { height: '20px', width: '20px', borderRadius: '5px' },
            type: "icon"
          })
        ])
      ])
    ])
  ], 64))
}
}

})